import { render } from "./DataViewContent.vue?vue&type=template&id=961ac0b4"
import script from "./DataViewContent.vue?vue&type=script&lang=js"
export * from "./DataViewContent.vue?vue&type=script&lang=js"

import "./DataViewContent.vue?vue&type=style&index=0&id=961ac0b4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__